import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table, UncontrolledTooltip } from "reactstrap";
import usageSVg from '../../assets/images/svg/usage.svg'
import { numberWithCommas } from "../../helpers/globalHelper";
import { useCommonDataFindAllQuery, useUsageCreateMutation, useUsageDeleteMutation, useUsageFindAllQuery, useUsageUpdateMutation } from "store";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import DeleteModal from "Components/Common/DeleteModal";

const UsageIndex = (props: any) => {

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [usageOne, setUsageOne] = useState<any>();
  const [usageTypeList, setUsageTypeList] = useState<any>();
  const [usageList, setUsageList] = useState<any>();
  const [usageCount, setUsageCount] = useState<any>();



  const {
    data: commonData,
    error: commonDataError,
    isFetching: isCommonDataFetching,
  } = useCommonDataFindAllQuery('?group_name=cmd_usage_type');

  const {
    data: usageData,
    error: usageDataError,
    isFetching: isUsageDataFetching,
  } = useUsageFindAllQuery(`?table_name=${props?.table_name}&connection_id=${props?.id}`);


  const [usageUpdate, usageUpdateResult] = useUsageUpdateMutation();
  const [usageCreate, usageCreateResult] = useUsageCreateMutation();
  const [usageDelete, usageDeleteResult] = useUsageDeleteMutation();


  useEffect(() => {
    setUsageTypeList(commonData?.data)
    setUsageList(usageData?.data)
    setUsageCount(usageData?.data?.length)
  }, [commonData, props?.id, props?.table_name, usageData])

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setUsageOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const tempUsage = arg;
    setUsageOne({
      id: tempUsage.id,
      cmd_usage_type: tempUsage.cmd_usage_type,
    });
    setIsEdit(true);
    toggle();
  }, []);

  const handleJobClicks = () => {
    setIsEdit(false);
    setUsageOne(null);
    toggle();
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (item) => {
    setUsageOne(item);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (usageOne) {
      usageDelete(usageOne?.id)
      setDeleteModal(false);
    }
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      cmd_usage_type: usageOne?.cmd_usage_type,
    },
    validationSchema: Yup.object({}),
    onSubmit: (values: any) => {
      if (isEdit) {
        const updateUsageList = {
          id: usageOne ? usageOne.id : 0,
          cmd_usage_type: values.cmd_usage_type,
          table_name: props?.table_name
        };
        usageUpdate(updateUsageList);
      } else {
        const newUsageList = {
          table_name: props?.table_name,
          connection_id: props?.id,
          cmd_usage_type: values["cmd_usage_type"],
        };
        usageCreate(newUsageList)
      }
      validation.resetForm();
      toggle();
    },
  });

  return (
    <React.Fragment>
      <style>
        {`
          .modal-backdrop.show{
            opacity: 0.5;
          }
        `}
      </style>
      <DeleteModal
        deleteName={usageOne?.usage_type_name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row className="d-flex justify-content-center">
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={usageSVg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {numberWithCommas(usageCount)}
                  </span>
                </li>
              </ul>
            </div>
            <button
              type="button"
              onClick={() => {
                handleJobClicks();
              }}
              className="btn btn-success  btn-label"
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
            </button>
          </div>
        </Col>
        <Col xl={6}>


          <div className="table-responsive">
            <Table className="table mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th> Ашиглах нөхцөл </th>
                  <th> Үйлдэл </th>
                </tr>
              </thead>
              <tbody>
                {usageList?.map((item, index) => (
                  <tr>
                    <th scope="row">{index + 1}</th>
                    <td>{item?.usage_type_name}</td>
                    <td>
                      <ul className="list-unstyled hstack gap-1 mb-0">
                        <li>
                          <Link
                            to="#"
                            className="btn btn-sm btn-soft-info"
                            onClick={(event: any) => {
                              event.preventDefault();
                              handleJobClick(item);
                            }}
                          >
                            <i className="mdi mdi-pencil-outline" id="edittooltip" />
                            <UncontrolledTooltip placement="top" target="edittooltip">
                              Засах
                            </UncontrolledTooltip>
                          </Link>
                        </li>

                        <li>
                          <Link
                            to="#"
                            className="btn btn-sm btn-soft-danger"
                            onClick={(event: any) => {
                              event.preventDefault();
                              onClickDelete(item);
                            }}
                          >
                            <i className="mdi mdi-delete-outline" id="deletetooltip" />
                            <UncontrolledTooltip placement="top" target="deletetooltip">
                              Soft delete
                            </UncontrolledTooltip>
                          </Link>
                        </li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

        </Col>
      </Row>

      <Modal
        isOpen={modal_backdrop}
        toggle={toggle}
        backdrop={'static'}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Ашиглалтын чиглэл засах" : "Ашиглалтын чиглэл нэмэх"}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="mb-3">
              {/* <Label> Role Меню </Label> */}
              <Input
                name="cmd_usage_type"
                type="select"
                className="form-select"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.cmd_usage_type || ""}
              >
                <option disabled value="">Сонгох</option>
                {/* {usageTypeList?.map((item, index) => (
                  <option value={item?.id}>{item?.name}</option>
                ))} */}
                {usageTypeList?.filter(item => !usageList?.some(myUsage => item?.id === myUsage?.cmd_usage_type))
                  .map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))
                }
              </Input>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="text-end">
              <Button type="submit" color="success" className="save-user" > Хадгалах </Button>
            </div>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  )
}

export default UsageIndex;